import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { isDescendant } from '../../helpers/helpers';

const SmarterFauxSelect = observer(class SmarterFauxSelect extends React.Component {

  componentWillMount() {
    this.state = {
      default: this.props.default || 'Select…',
      highlighted: -1,
      active: false
    }
  }

  componentDidMount() {
    // Hide when anything else is clicked
    document.addEventListener('click', (e) => {
      if(this.state.active && !isDescendant(this.refs.fauxSelect, e.target)) {
        this.setState({
          active: false,
          highlighted: -1
        });
      }
    });
  }

  clickOption(e, index) {
    const { onClick, parent, skipText } = this.props;

    // Unless otherwise specified, update the text of the dropdown selection
    if (!skipText) {
      this.setState({
        default: e.target.getAttribute('data-label')
      });
    }
    if (parent) {
      parent.setState({
        action: e.target.getAttribute('data-action')
      })
    }
    if (onClick) {
      onClick(e, this.props, index);
    }
    this.hide();
  }

  renderTooltip(key) {
    if(key.helper) {
      return (
        <div className="tooltip tooltip--right" onClick={(e) => {e.stopPropagation()}}>
          <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
          <div id={`${key.action}-tooltip`} className="tooltip__body" role="tooltip">
            {key.helper}
          </div>
        </div>
      );
    }

    return '';
  }

  toggle = (e) => {
    if (this.state.active) {
      this.hide();
    } else {
      this.showFirst(e);
    }
  }

  showFirst = (e) => {
    this.setState({
      active: true
    }, () => {
      this.focusOption(0);
    });
  }

  showLast = (e) => {
    this.setState({
      active: true
    }, () => {
      this.focusOption(this.props.options.length - 1);
    });
  }

  hide = () => {
    this.setState({
      highlighted: -1,
      active: false
    })
  }

  focusOption = (index) => {
    if (index >= 0) {
      this.setState({
        highlighted: index
      }, () => {
        this.refs[`option-${this.state.highlighted}`].focus();
      })
    }
  }

  checkKey = (e) => {
    const first = 0;
    const last = this.props.options.length - 1;

    const ESCAPE = 27;
    const END = 35;
    const HOME = 36;
    const TAB = 9;
    const DOWN_ARROW = 40;
    const UP_ARROW = 38;

    switch(e.keyCode) {
      case ESCAPE:
        this.hide();
        this.refs.trigger.focus();
        break;
      case HOME:
        if (this.state.active) {
          e.preventDefault();
          this.focusOption(first);
        }
        break;
      case END:
        if (this.state.active) {
          e.preventDefault();
          this.focusOption(last);
        }
        break;
      case TAB:
        if (this.state.active) {
          this.hide();
        }
        break;
      case UP_ARROW:
        e.preventDefault();
        if (!this.state.active) {
          this.showLast();
        } else {
          if (this.state.highlighted > 0) {
            this.focusOption(this.state.highlighted - 1);
          } else {
            this.focusOption(last);
          }
        }
        break;
      case DOWN_ARROW:
        e.preventDefault();
        if (!this.state.active) {
          this.showFirst();
        } else {
          if (this.state.highlighted < last) {
            this.focusOption(this.state.highlighted + 1);
          } else {
            this.focusOption(first);
          }
        }
        break;
      default:
        break;
    }
  }

  render() {
    const { options, selectIndex } = this.props;

    return(
      <div
        className={`faux-select ${this.state.active ? "dropdown--active" : "dropdown--closed"}`}
        ref="fauxSelect"
        onKeyDown={this.checkKey}
      >
          <button
            id={`faux-select__trigger-${selectIndex}`}
            ref="trigger"
            className="faux-select__selected"
            aria-haspopup="true"
            aria-controls={`faux-select__content-${selectIndex}`}
            aria-expanded={this.state.active ? "true" : "false"}
            onClick={this.toggle}
          >
            {this.state.default}
          </button>

          {this.props.store ?
            <this.props.store.validater>
              <ul
                id={`faux-select__content-${selectIndex}`}
                role="menu"
                className={`faux-select__options dropdown__menu ${this.props.noTooltip ? '' : 'has-tooltip'}`}
                aria-labelledby={`faux-select__trigger-${selectIndex}`}
                hidden={this.state.active ? false : true}
                aria-hidden={this.state.active ? false : true}
              >
                {options.map(
                  (key, i) => {
                  if(key.iamAction && key.iamResource) {
                    return (
                      <li
                        iamAction={key.iamAction}
                        iamResource={key.iamResource}
                        key={i}
                        className={`${key.helper ? 'has-tooltip' : ''}`}
                        role="menuitem" 
                        tabIndex="-1"
                      >
                        <button
                          className={`faux-select__btn ${this.state.highlighted === i ? 'highlighted' : ''}`}
                          onClick={(e, i) => {this.clickOption(e, i)}}
                          data-label={key.title}
                          data-action={key.action}
                          aria-labelledby={`${key.action}-tooltip`}
                          ref={`option-${i}`}
                        >
                          {key.title}

                          {key.subTitle &&
                            <span className="faux-select__subtitle" data-label={key.title}>{key.subTitle}</span>
                          }
                        </button>

                        {this.renderTooltip(key)}
                      </li>
                    )
                  } else {
                    return (
                      <li
                        key={i}
                        role="menuitem"
                        tabIndex="-1"
                        className={`${key.helper ? 'has-tooltip' : ''}`}
                      >
                        <button
                          className={`faux-select__btn ${this.state.highlighted === i ? 'highlighted' : ''}`}
                          onClick={(e) => {this.clickOption(e, i)}}
                          data-label={key.title}
                          data-action={key.action}
                          aria-labelledby={`${key.action}-tooltip`}
                          ref={`option-${i}`}
                        >
                          {key.title}

                          {key.subTitle &&
                            <span className="faux-select__subtitle" data-label={key.title}>{key.subTitle}</span>
                          }
                        </button>

                        {this.renderTooltip(key)}
                      </li>
                    )
                  }
                })}
              </ul>
            </this.props.store.validater>
            :
              <ul
                id={`faux-select__content-${selectIndex}`}
                role="menu"
                className={`faux-select__options dropdown__menu ${this.props.noTooltip ? '' : 'has-tooltip'}`}
                aria-labelledby={`faux-select__trigger-${selectIndex}`}
                hidden={this.state.active ? false : true}
                aria-hidden={this.state.active ? false : true}
              >
                {options.map(
                  (key, i) =>
                  <li key={i} className={`${key.helper ? 'has-tooltip' : ''}`} role="menuitem" tabIndex="-1">
                    <button
                      className={`faux-select__btn ${this.state.highlighted === i ? 'highlighted' : ''}`}
                      onClick={(e) => {this.clickOption(e, i)}}
                      data-label={key.title}
                      data-action={key.action}
                      aria-labelledby={`${key.action}-tooltip`}
                      ref={`option-${i}`}
                    >
                      {key.title}

                      {key.subTitle &&
                        <span className="faux-select__subtitle" data-label={key.title}>{key.subTitle}</span>
                      }
                    </button>

                    {this.renderTooltip(key)}
                  </li>
                )}
              </ul>
          }
      </div>
    );
  }
})

export default SmarterFauxSelect;



// WEBPACK FOOTER //
// ./src/app/components/Common/SmarterFauxSelect.js